import { render, staticRenderFns } from "./FormFile.vue?vue&type=template&id=75cc1ce8"
import script from "./FormFile.vue?vue&type=script&lang=ts"
export * from "./FormFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports